import { render } from "./MerchantManageListForm.vue?vue&type=template&id=1edd08f5&lang=true"
import script from "./MerchantManageListForm.vue?vue&type=script&lang=js"
export * from "./MerchantManageListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__